import { gql } from "@apollo/client";export default gql`mutation insert_group_collection_one($collection_id: Int, $group_id: Int, $order: Int) {
    insert_group_collection_one(
        object: { collection_id: $collection_id, group_id: $group_id, order: $order }
    ) {
        id
    }
}
`;
